<app-features-container
  [header]="'+INSTALLATIONS.INSTALLATION.WALLBOX.SYSTEM_TILE' | translate"
  [overlayType]="availableOverlays.WallboxSystem"
  [powerLimitationLabel]="powerLimitationLabel$ | async"
>
  <!-- vcs.displayed.power -->
  <app-feature-tile
    *ngrxLet="chargingPower$ | async | ready as feature"
    data-at-cascade-dhw-mode-power
    feature
    [label]="
      (displayedStatus$ | async | ready | value2: FeaturePropertyKey.status) ===
      wallboxStatuses.charging
        ? (phasesTranslationKey | translate)
        : ('+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGING_POWER' | translate)
    "
    value="{{ feature | value2: FeaturePropertyKey.value }} {{ feature | unit: 'value' }}"
    [attr.data-feature]="feature?.feature"
  ></app-feature-tile>

  <!-- vcs.displayed.substatus -->
  <!-- vcs.displayed.status -->

  <ng-container *ngIf="displayedStatus$ | async | ready as status" feature>
    <app-feature-tile
      [attr.data-at-wallbox-status]="status | value2: FeaturePropertyKey.status"
      [attr.data-at-wallbox-substatus]="
        displayedSubstatus$ | async | value2: FeaturePropertyKey.substatus
      "
      feature
      [label]="
        (displayedSubstatus$ | async | ready)
          ? (chargingTranslationKey +
              (displayedSubstatus$
                | async
                | ready
                | value2: FeaturePropertyKey.substatus
                | uppercase) | translate)
          : ''
      "
      [value]="
        chargingTranslationKey + (status | value2: FeaturePropertyKey.status | uppercase)
          | translate
      "
    ></app-feature-tile>
  </ng-container>

  <!-- vcs.session.charging -->
  <ng-container *ngIf="sessionCharging$ | async | ready as feature" feature>
    <app-feature-tile
      data-at-cascade-dhw-mode-charging-energy
      feature
      [label]="'+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGED_ENERGY_IN_CURRENT_SESSION' | translate"
      value="{{ feature | value2: FeaturePropertyKey.energy }} {{ feature | unit: 'energy' }}"
      [attr.data-feature]="feature.feature + '/energy'"
    ></app-feature-tile>
    <app-feature-tile
      *ngIf="displayedStatus$ | async | ready"
      data-at-cascade-dhw-mode-charging-time
      feature
      [label]="'+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGING_TIME' | translate"
      value="{{ feature?.properties?.time?.value | secondsTimeFormatter: 'HH:mm' }} {{
        SUFFIX.hour
      }}"
      [attr.data-feature]="feature.feature + '/time'"
    ></app-feature-tile>
  </ng-container>
</app-features-container>
